import React, { memo } from "react";
import { VStack } from "@chakra-ui/react";

import PublicCard, { type PublicCardTone } from "./PublicCard";
import WithHeading2 from "./WithHeading2";
import WithPageIntro from "./WithPageIntro";

export type PublicMessageType = "error" | "info" | "success" | "warning";

export type PublicMessageProps = {
  title: string;
  message: string;
  type?: PublicMessageType;
};

const PUBLIC_MESSAGE_TONES: Record<PublicMessageType, PublicCardTone> = {
  error: "danger",
  info: "primary",
  success: "success",
  warning: "warning",
};

function PublicMessage({
  title,
  message,
  type = "info",
}: PublicMessageProps) {
  const tone = PUBLIC_MESSAGE_TONES[type];

  return (
    <PublicCard
      as="section"
      tone={tone}
      variant="tinted"
      maxW="container.sm"
      mx="auto"
      py={{ base: "8", md: "10" }}
      textAlign="center"
    >
      <VStack spaceY="4">
        <WithHeading2
          textAlign="center"
          color={`moveon.${tone === "danger" ? "danger" : tone}`}
          pt="0"
        >
          {title}
        </WithHeading2>
        <WithPageIntro textAlign="center" mt="0">
          {message}
        </WithPageIntro>
      </VStack>
    </PublicCard>
  );
}

export default memo(PublicMessage);
